import styles from "./Profile.module.css"

const Profile = () => {
  return (
    <div className={styles.profileContainer} >
        <div className={`${styles.profileCard} glass-card`}>
            profile
        </div>
    </div>
  )
}

export default Profile